/* eslint-disable @typescript-eslint/no-explicit-any -- richiede ulteriori verifiche */
import {
  BackToCatalogButton,
  CheckCatalogButton,
  GoToCatalogButton,
  GoToCatalogSearchButton,
} from 'app/src/shared/components/CatalogButtons'
import { JoinButton } from 'app/src/shared/components/JoinButton'
import { InjectDecorator } from 'app/src/shared/helpers/htmlToReact/components'
import { ProcessNodeDefinitions } from 'html-to-react'

type ComponentMap = {
  [key: string]: (props?: any) => React.ReactNode
}

const componentsToProcess: ComponentMap[] = [
  { membershipjoinbutton: (props?: any) => <JoinButton {...props} /> },
  { gotocatalogbutton: (props?: any) => <GoToCatalogButton {...props} /> },
  { backtocatalogbutton: (props?: any) => <BackToCatalogButton {...props} /> },
  { gotocatalogsearchbutton: (props?: any) => <GoToCatalogSearchButton {...props} /> },
  { checkcatalogbutton: (props?: any) => <CheckCatalogButton {...props} /> },
]

const shouldProcessInjectionNode = (node: any, componentKeys: string[]) => {
  return (
    typeof node?.attribs?.['data-welfare-componentid'] !== 'undefined' &&
    componentKeys.includes(node?.attribs?.['data-welfare-componentid'])
  )
}

const findComponent = (componentId: string, components: ComponentMap[]) => {
  for (const componentMap of components) {
    if (componentMap[componentId]) {
      return componentMap[componentId]
    }
  }
  return null
}

export const getProcessingInstructions = () => [
  {
    shouldProcessNode: function (node: any) {
      return shouldProcessInjectionNode(node, componentsToProcess.flatMap(Object.keys))
    },
    processNode: function (node: any /*, children: any*/) {
      //(node:any, children:any) {
      const componentId: string = node?.attribs?.['data-welfare-componentid']
      const child = findComponent(componentId, componentsToProcess)
      return <InjectDecorator node={node}>{child?.({ attribs: node?.attribs })}</InjectDecorator>
    },
  },
  {
    shouldProcessNode: function () {
      return true
    },
    processNode: ProcessNodeDefinitions().processDefaultNode,
  },
]
